import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaFileAlt, 
    FaArrowLeft, 
    FaSort,
    FaCalendarAlt,
    FaSearch
} from 'react-icons/fa';

const EngineerSubheCertificates = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [eligibility, setEligibility] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [year, setYear] = useState('');

    // Marathi numerals for Sr.No.
    const marathiNumerals = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    const toMarathiNumber = (n) => String(n).split('').map(digit => marathiNumerals[parseInt(digit)]).join('');

    // Dummy data matching the image
    const [data] = useState([
        {
            id: 1,
            name: "विशाल किसन हाडवे",
            address: "राजुरी ता- जुन्नर जि-पुणे-",
            approvedDate: "२९ डिसेंबर २०२३",
            category: "व्यावसायिक कंत्राटदार",
            regNo: "५०/२०२४",
            regClass: "वर्ग ७ (सात)",
            validity: "२९/१२/२०२३ ते २८/१२/२०२८"
        },
        {
            id: 2,
            name: "श्री.राजेश्वर रोहिदास",
            address: "मु.पो.मांजरी बु.हडपसर,ता.हवेली,जि.पुणे.",
            approvedDate: "२९ डिसेंबर २०२३",
            category: "व्यावसायिक कंत्राटदार",
            regNo: "५१/२०२४",
            regClass: "वर्ग ७ (सात)",
            validity: "२९/१२/२०२३ ते २८/१२/२०२८"
        },
        {
            id: 3,
            name: "विश्वास दत्तात्रय जाधव",
            address: "मु.पो.तुपे नगर,हडपसर,ता.हवेली,जि.पुणे",
            approvedDate: "२९ डिसेंबर २०२३",
            category: "व्यावसायिक कंत्राटदार",
            regNo: "५२/२०२४",
            regClass: "वर्ग ७ (सात)",
            validity: "२९/१२/२०२३ ते २८/१२/२०२८"
        },
        {
            id: 4,
            name: "श्री.शंतनु सयाजी कापून",
            address: "मु.पो.कसुबे ा इंदापूर,ता.इंदापूर,जि.पुणे.",
            approvedDate: "२९ डिसेंबर २०२३",
            category: "व्यावसायिक कंत्राटदार",
            regNo: "५३/२०२४",
            regClass: "वर्ग ७ (सात)",
            validity: "२९/१२/२०२३ ते २८/१२/२०२८"
        }
    ]);

    const filteredData = data.filter(item => 
        item.name.includes(searchTerm) || 
        item.address.includes(searchTerm)
    );

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-marathi">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-8 px-2">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate('/engineer/reports-menu')}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={16} />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800 tracking-tight">मंजूर अर्ज अहवाल</h1>
                    </div>
                    <div className="text-xs font-medium text-gray-400">
                        जिल्हा परिषद / <span className="text-gray-500 font-bold tracking-tight">मंजूर अर्ज अहवाल</span>
                    </div>
                </div>

                {/* Filter Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 mb-8">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 items-end">
                        <div className="space-y-2">
                            <label className="text-sm font-bold text-gray-500">पात्रता (पात्रता) <span className="text-red-500">*</span></label>
                            <select 
                                className="w-full border border-gray-200 rounded-lg px-4 py-2 outline-none focus:border-blue-500 bg-gray-50/30 text-gray-400 font-bold"
                                value={eligibility}
                                onChange={(e) => setEligibility(e.target.value)}
                            >
                                <option value="">पात्रता निवडा</option>
                                <option value="eligible">पात्र</option>
                                <option value="not">अपात्र</option>
                            </select>
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-bold text-gray-500">तारखेपासून</label>
                            <input 
                                type="date" 
                                className="w-full border border-gray-200 rounded-lg px-4 py-2 outline-none focus:border-blue-500 bg-gray-50/30 text-gray-400"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-bold text-gray-500">आजपर्यंत</label>
                            <input 
                                type="date" 
                                className="w-full border border-gray-200 rounded-lg px-4 py-2 outline-none focus:border-blue-500 bg-gray-50/30 text-gray-400"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                            />
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-bold text-gray-500">वर्ष</label>
                            <select 
                                className="w-full border border-gray-200 rounded-lg px-4 py-2 outline-none focus:border-blue-500 bg-gray-50/30 text-gray-400 font-bold"
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                            >
                                <option value="">वर्ष निवडा</option>
                                <option value="2023">२०२३</option>
                                <option value="2024">२०२४</option>
                            </select>
                        </div>
                        <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2.5 rounded-lg font-bold shadow-md shadow-blue-100 transition transform active:scale-95 flex items-center justify-center gap-2">
                            शोध
                        </button>
                    </div>

                    <div className="mt-12 pt-8 border-t border-gray-50">
                        {/* Toolbar */}
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8">
                            <div className="flex rounded-lg overflow-hidden border border-gray-200 shadow-sm">
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-6 py-2 text-xs font-bold transition">कॉपी करा</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-6 py-2 text-xs font-bold border-l border-gray-500 transition">एक्सेल</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-6 py-2 text-xs font-bold border-l border-gray-500 transition">प्रिंट</button>
                            </div>
                            <div className="flex items-center gap-3">
                                <label className="text-sm font-bold text-gray-600">शोध:</label>
                                <input 
                                    type="text" 
                                    className="border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:border-blue-500 transition-all font-medium bg-gray-50/30 w-72"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className="border border-gray-100 rounded-xl overflow-x-auto shadow-sm">
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr className="bg-white border-b border-gray-200">
                                        <th className="px-4 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 w-20">
                                            <div className="flex items-center justify-between"># <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 min-w-[200px]">
                                            <div className="flex items-center justify-between">अर्जदाराचे नाव <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 min-w-[300px]">
                                            <div className="flex items-center justify-between">पत्ता <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 w-40">
                                            <div className="flex items-center justify-between">मंजूर तारीख <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 w-48">
                                            <div className="flex items-center justify-between">खाली. <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 w-32">
                                            <div className="flex items-center justify-between">रेजी. नाही. <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 w-32">
                                            <div className="flex items-center justify-between">रेजि. वर्ग <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-left border-r border-gray-100 uppercase group cursor-pointer hover:bg-gray-50 min-w-[250px]">
                                            <div className="flex items-center justify-between">प्रमाणपत्र मुदत <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                        <th className="px-6 py-5 text-[12px] font-black text-gray-800 text-center uppercase group cursor-pointer hover:bg-gray-50 w-32">
                                            <div className="flex items-center justify-center">स्वाक्षरी <FaSort className="text-gray-300 opacity-0 group-hover:opacity-100 transition" /></div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((item, index) => (
                                        <tr key={item.id} className="hover:bg-blue-50/20 group transition-colors border-b border-gray-50 last:border-0 text-[13px] text-gray-600 font-bold">
                                            <td className="px-4 py-6 border-r border-gray-100">{toMarathiNumber(item.id)}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi">{item.name}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi leading-relaxed">{item.address}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi">{item.approvedDate}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi">{item.category}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi">{item.regNo}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi">{item.regClass}</td>
                                            <td className="px-6 py-6 border-r border-gray-100 font-marathi leading-relaxed">{item.validity}</td>
                                            <td className="px-6 py-6 text-center">
                                                <div className="h-10 w-24 bg-gray-50/50 rounded-lg mx-auto"></div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerSubheCertificates;
